<template>
    <div>
        <el-dialog v-model="learningGuideShow" title="Tips" width="500" :show-close="false">
            <template #header>
                <div class="header">操作指引</div>
                <div class="close_icon" @click="closeDialog">
                    <el-icon :size="20">
                        <CloseBold />
                    </el-icon>
                </div>
            </template>
            <div class="dialog_content">
                <div class="content">
                    <div v-for="(item, index) in guideList" :key="index">
                        <el-image class="guide_icon" :src="imgPath(item.icon)" v-if="currentIndex == index"></el-image>
                    </div>
                </div>
                <div class="confirm_btn_box flex Flexjustify Flexalign mt-5">
                    <div class="btn_cancel cursor_pointer" v-if="currentIndex != 0" @click="changeStep('desc')">上一步
                    </div>
                    <div class="btn_cancel btn_confirm cursor_pointer ml-40" @click="changeStep('inc')">{{
                        currentIndex ==
                        4?'已了解':'下一步' }}</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { debounce } from "@/assets/utils/dbucTrtl";
export default {
    name: "GjkcH5LearningGuide",

    data() {
        return {
            learningGuideShow: false,
            guideList: [
                { icon: "guide_img1.png" },
                { icon: "guide_img2.png" },
                { icon: "guide_img3.png" },
                { icon: "guide_img4.png" },
                { icon: "guide_img5.png" },
            ],
            currentIndex: 0,
        };
    },

    mounted() { },

    methods: {
        changeStep(type) {
            if (type == 'desc') {
                debounce(() => {
                    this.currentIndex--
                },
                    500,
                    false)()
            } else {
                if (this.currentIndex == 4) {
                    this.closeDialog();
                    return
                }
                debounce(() => {
                    console.log(this.currentIndex)
                    this.currentIndex++
                },
                    500,
                    false)()
            }
        },
        closeDialog() {
            this.learningGuideShow = false;
        }
    },
};
</script>
<style lang="scss" scoped>
:deep(.el-dialog) {
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
    border-radius: 10px;
    padding: 0;
    width: 918px;
    height: 655px;
    background: #FFFFFF;
    position: relative;
}

:deep(.el-dialog__header) {
    position: relative;
    padding: 0 20px;
    box-sizing: border-box;
    text-align: start;
}

.header {
    font-size: 20px;
    color: #333333;
    line-height: 60px;
    border-bottom: 1px solid rgba(36, 35, 36, 0.1);
}

.close_icon {
    position: absolute;
    top: 20px;
    right: 20px;
    color: #333333;
}

.dialog_content {
    .content {
        width: 100%;
        font-size: 18px;
        color: #111111;
        padding: 20px;
        box-sizing: border-box;
        line-height: 36px;

        .guide_icon {
            width: 870px;
            height: 480px;
            border-radius: 10px;
        }
    }

    .confirm_btn_box {
        .btn_cancel {
            background: #fff;
            line-height: 38px;
            text-align: center;
            font-size: 18px;
            color: #13D6AA;
            width: 120px;
            height: 38px;
            border-radius: 24px;
            border: 1px solid #13D6AA;
        }

        .btn_confirm {
            color: #fff;
            background: linear-gradient(90deg, #00DEC9, #00DCA1);
        }
    }
}
</style>